import getStorageKeyPrefix from '@/shared/utils/getStorageKeyPrefix';

export const practitionerSelectedKey = `${getStorageKeyPrefix()}_PATIENT_LIST_PRACTITIONER_ID`;
